module.exports = __webpack_public_path__ + "static/cartabsLayout1Back-90cad5f4a1d01adeabec71a092390806.png";